import script from "./ProductsData.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsData.vue?vue&type=script&setup=true&lang=js"

import "./ProductsData.vue?vue&type=style&index=0&id=153ccc9c&lang=css"

const __exports__ = script;

export default __exports__